import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';

import { translate as t } from '../../../../lib/I18n';
import OrderFare from '../../../../records/order/Fare';

import BaseModal from '../../../general/BaseModal';
import FareShort from '../../../checkout/FareShort';
import Icon from '../../../general/Icon';
import Page from '../../../general/Page';

function AmendedSplitFaresModal({ fares, ticketTypeName, show, onClose }) {
    const modalProps = {
        show,
        className: 'fare-modal grid-modal modal--sm amended-split-fares-modal',
        onClose,
        header: (
            <Page title={ ticketTypeName } goBack={ false }>
                <h1 className="modal-title text-left">
                    <Icon icon="splitticket" className="split-ticket-icon otrl-inline" style={{ color: 'white' }} />
                </h1>
            </Page>
        ),
        footer: (
            <Button
                className="action-btn action-btn--secondary pull-left"
                onClick={ onClose }
            >
                { t('button.text.close') }
            </Button>
        ),
        hideContinue: true,
    };

    return (
        <BaseModal { ...modalProps }>
            { fares.map((fare, i) => (
                <div key={ fare.id ?? i }>
                    { i > 0 && <hr /> }
                    <FareShort orderFare={ fare } stationsColWidth={ 8 } ticketTypeColWidth={ 4 } />
                </div>
            )) }
        </BaseModal>
    );
}

AmendedSplitFaresModal.propTypes = {
    fares: PropTypes.arrayOf(PropTypes.instanceOf(OrderFare)).isRequired,
    ticketTypeName: PropTypes.string,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

AmendedSplitFaresModal.defaultProps = {
    ticketTypeName: '',
};

export default AmendedSplitFaresModal;
